
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help"
import Konva from "konva"

class TextElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, "text", x, y, {
      text: "文本",
      port: true,
      ...attrs
    })
    // 底座加载完成时调用
    this.onLoad(() => {
      // 不需要显示名称
      this.label.visible(false)
      this.ports.hide()
    })
  }

  bindPortEvent() {
    // 覆盖默认的绑定事件
  }


  addKeyShape(name, attrs) {
    this.keyShape = this._createDarthNode()
    this.g.add(this.keyShape)

    setTimeout(() => {
      this.executeLoadedHook(this.keyShape)
    })
  }

  _createDarthNode() {

    let text = new Konva.Text({
      // width: 20,
      // height: 10,
      text: "文本",
      fill: "rgba(0, 0, 0, 1)",
      fontSize: 14,
      x: 0,
      y: 0
    })

    text.offsetX(text.width() / 2)

    return text
  }

}

export { TextElement }
